import { render } from "./Evaluate.vue?vue&type=template&id=3589573c&scoped=true"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"

import "./Evaluate.vue?vue&type=style&index=0&id=3589573c&lang=css"
import "./Evaluate.vue?vue&type=style&index=1&id=3589573c&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3589573c"]])

export default __exports__